// extracted by mini-css-extract-plugin
module.exports = {"Container":"Dashboard_Container__t-VVI"};